<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>{{ $t("actions.close") }}</title>
    <path
      d="M23 3.223L20.777 1 12 9.777 3.223 1 1 3.223 9.777 12 1 20.777 3.223 23 12 14.223 20.777 23 23 20.777 14.223 12z"
      fill-rule="nonzero"
    />
  </svg>
</template>
